import axios from './axios';
import qs from 'qs';

export default {
  getById: async (id, params) => {
    const body = { params };
    const { data } = await axios.get(`/documents/${id}/revision`, body);
    return data;
  },

  addSuggestion: async (id, body, params) => {
    const { data } = await axios.post(`/revisions/${id}/suggestion`, body, {
      params: { ...params },
      paramsSerializer: params => {
        return qs.stringify(params);
      }
    });

    return data;
  },

  update: (id, body) => {
    const { data } = axios.put(`/revisions/${id}`, body);
    return data;
  }
};
